module.exports = __webpack_public_path__ + "static/media/liveroom-manage-bg.99739529.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-manage-bg.png
// module id = 1967
// module chunks = 6